// extracted by mini-css-extract-plugin
export default {"expandedMenu":"header_expandedMenu__XUvVf","active":"header_active__r-ZIM"};